module.exports = __webpack_public_path__ + "img/page_4_3.074522f2.png";